import { render } from "./PDetails.vue?vue&type=template&id=017d8abf&scoped=true"
import script from "./PDetails.vue?vue&type=script&lang=js"
export * from "./PDetails.vue?vue&type=script&lang=js"

import "./PDetails.vue?vue&type=style&index=0&id=017d8abf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017d8abf"]])

export default __exports__